import React from 'react';

const ConfirmationModal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title = "Confirm Action", 
    message = "Are you sure you want to proceed?",
    confirmText = "Confirm",
    cancelText = "Cancel",
    confirmButtonClass = "btn-primary",
    isLoading = false
}) => {
    return (
        <div 
            className={`modal fade ${isOpen ? 'show d-block' : ''}`} 
            tabIndex="-1" 
            role="dialog"
            style={{ backgroundColor: isOpen ? 'rgba(0,0,0,0.5)' : 'transparent' }}
        >
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content shadow-lg border-0">
                    <div className="modal-header border-0 pb-0">
                        <h5 className="modal-title fw-bold fs-4">{title}</h5>
                        <button 
                            type="button" 
                            className="btn-close" 
                            onClick={onClose} 
                            aria-label="Close"
                            disabled={isLoading}
                        ></button>
                    </div>
                    <div className="modal-body py-4">
                        <p className="fs-6 text-gray-700 mb-0">{message}</p>
                    </div>
                    <div className="modal-footer border-0 pt-0">
                        <button 
                            type="button" 
                            className="btn btn-light-secondary fw-bold" 
                            onClick={onClose}
                            disabled={isLoading}
                        >
                            {cancelText}
                        </button>
                        <button 
                            type="button" 
                            className={`btn ${confirmButtonClass} fw-bold`} 
                            onClick={onConfirm}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Processing...
                                </>
                            ) : confirmText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
